module.exports = __webpack_public_path__ + "img/OndemandVideoOutlined.db8a72fa.svg";